module.exports = __webpack_public_path__ + "img/txjls.b557a239.png";